import AgTypography from '../../../Styles/AgTypography';
import AgTab, { AgTabsDataProps } from '../../AgTab';
import { AgColor } from '../../../Styles/AgColor';
import { CSSProperties, Dispatch, MouseEventHandler, SetStateAction } from 'react';
import { useIntl } from 'react-intl';
import AgLoadingButton from '../../../AgLoadingButton';

export interface AgProfileHeaderProps {
  tabsData?: AgTabsDataProps[];
  buttonLabel?: string;
  buttonDisabled?: boolean;
  buttonHide?: boolean;
  cardTitle?: string;
  cardID?: string;
  cardInfo?: string;
  onClick?: MouseEventHandler;
  hasPersonalDetailsError?: boolean;
  hasMemberProfileError?: boolean;
  isButtonLoading?: boolean;
  setValueForSaveBtn?: Dispatch<SetStateAction<number>>;
  style?: CSSProperties;
  updatedTabValue?: number;
  // eslint-disable-next-line no-unused-vars
  onTabChange?: (value: number) => void;
}

const AgProfileHeader = (
  {
    tabsData,
    buttonLabel,
    buttonDisabled,
    buttonHide,
    cardTitle,
    cardID,
    cardInfo,
    onClick,
    hasPersonalDetailsError,
    hasMemberProfileError,
    isButtonLoading,
    setValueForSaveBtn,
    updatedTabValue,
    style,
    onTabChange,
  }: AgProfileHeaderProps
) => {
  const messages = useIntl().formatMessage;

  return (
    <AgTypography
      style={{
        display: 'grid',
        boxShadow: '0px 1px 2px 0px #0000000D',
        backgroundColor: AgColor.grey0,
        ...style,
      }}
    >
      <AgTypography
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <AgTypography
          style={{
            display: 'grid',
            gap: '8px',
            padding: '10px 16px'
          }}
        >
          <AgTypography
            style={{
              color: AgColor.grey6
            }}
            contentStyle={'AP.Assistive.Text.SemiBold'}
            message={(tabsData?.length === 1 && !tabsData[0]?.label) ? messages({ id: 'MEMBER_REVIEW_DETAILS' }) : cardTitle}
          />
          <AgTypography>
            <AgTypography contentStyle={'AP.H3.Bold'} message={cardID} />
            <AgTypography
              style={{
                color: AgColor.grey7
              }}
              contentStyle={'AP.Assistive.Text.Regular'}
              message={(tabsData?.length === 1 && !tabsData[0]?.label) ? messages({ id: 'MEMBER_CARD_INFO' }) : cardInfo}
            />
          </AgTypography>
        </AgTypography>
        {
          !buttonHide && buttonLabel &&
          <AgLoadingButton
            dataTestId={'profile-header-button'}
            label={buttonLabel}
            loading={isButtonLoading}
            disabled={buttonDisabled}
            onClick={onClick}
            style={{
              height: '36px',
              marginTop: '12px',
              marginRight: '16px'
            }}
          />
        }
      </AgTypography>

      {tabsData &&
        <AgTab
          tabs={tabsData}
          hasPersonalDetailsError={hasPersonalDetailsError}
          hasMemberProfileError={hasMemberProfileError}
          setValueForSaveBtn={setValueForSaveBtn}
          updatedValue={updatedTabValue}
          onTabChange={onTabChange}
        />}
    </AgTypography>
  );
};

export default AgProfileHeader;